<template>
  <div class="pop-over">
    <div>
      <div v-if="showLoading">
        <h4>{{ $t("send_results.loading") }}</h4>
        <div class="loader"></div>
      </div>

      <div v-else-if="showSuccess">
        <h4>{{ $t("send_results.success") }} </h4>
        <h5>{{ $t("send_results.thank_you") }}</h5>

        <div class="footer">
          <div class="navigation-buttons" />

          <div class="navigation-buttons">
            <router-link :to="{ name: 'home' }">
              <button class="btn btn-outline-dark next" type="submit">
                {{ $t("send_results.home") }}
              </button>
            </router-link>
          </div>
        </div>

      </div>

      <div v-else-if="showError">
        <div @click="downloadData" class="download-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
            class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
            <path
              d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
            <path
              d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
          </svg>
          <div>{{ $t('download') + filename }}</div>
        </div>

        <div class="description">
          {{ $t('unexpected_error') }}
        </div>

        <div class="button-footer">
          <div class="navigation-buttons">
            <button class="btn btn-outline-dark back" type="submit" @click="close">
              {{ $t('back_2') }}
            </button>
          </div>

          <div class="navigation-buttons">

          </div>
        </div>

      </div>

      <div v-else>
        <div @click="downloadData" class="download-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
            class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
            <path
              d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
            <path
              d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
          </svg>
          <div>{{ $t('download') + filename }}</div>
        </div>

        <div class="description">
          {{ $t('conformation_internet2') }}
        </div>


        <div class="button-footer">
          <div class="navigation-buttons">
            <button class="btn btn-outline-dark back" type="submit" @click="close">
              {{ $t('back_2') }}
            </button>
          </div>

          <div class="navigation-buttons" @click="sendData()">
            <button class="btn btn-outline-dark next" type="submit">
              {{ $t('continue') }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'SendDataConformationPopup',
  data() {
    return {
      showSuccess: false,
      showLoading: false,
      filename: "",
      showError: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    downloadData() {
      const fileURL = window.URL.createObjectURL(new Blob([JSON.stringify(this.$store.state.answers)]));
      const fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', this.filename);
      document.body.appendChild(fileLink);

      fileLink.click();

    },

    // Quick fix for data sequence change
    changeSequence(array) {
      var list = []

      var newSequence = [
        "ISMS",
        "ORP",
        "CON",
        "OPS",
        "DER",
        "APP",
        "SYS",
        "IND",
        "NET",
        "INF"
      ]

      for (let i = 0; i < newSequence.length; i++) {
        list.push(array[newSequence[i]])
      }

      return list
    },

    getBenchmark() {
      axios
        .get(this.$store.state.metadata.benchmark)
        .then(response => {
          this.benchmark = response.data;

          this.benchmark?.forEach(b => {
            let vals = this.changeSequence(b);

            this.$store.state.benchmark.push(
              {
                "label": b.name[this.$i18n.locale],
                "data": vals,
              }
            )
          })

          setTimeout(() => {
            this.showLoading = false;
            window.scrollTo(0, 0);
            this.$router.push('/results')

          }, 500);

        }).catch(function (error) {
          console.log("Failed to load data: ", error);
        })
    },
    sendData() {
      // this.getBenchmark();
      // console.log(JSON.parse(JSON.stringify(this.$store.state.calculatedSummaryData)))
      this.showLoading = true
      if (this.$store.state.metadata === undefined) {
        this.showLoading = false;
        this.showError = true;
      } else {
        axios
          .post(this.$store.state.metadata.answers, JSON.parse(JSON.stringify(this.$store.state.calculatedSummaryData)),
            {
              headers: {
                "Access-Control-Allow-Origin": "https://localhost:8080",
                "Content-Type": "application/json"
              },
            })
          .then((response) => {
            if (response.status === 200) {
              this.$store.state.calculatedSummaryData["id"] = response.data.answerid;
              this.getBenchmark();
            } else {
              console.log("Error has occurred: ", response);
              this.showError = true;

            }
          }).catch((error) => {
            console.log("Failed to load data: ", error);

            this.showLoading = false;
            this.showError = true;

          })
      }
    }
  },
  mounted() {
    const currentdate = new Date();
    this.filename = "MASS_detailed_answers" + currentdate.getDate() + "_"
      + (currentdate.getMonth() + 1) + "_"
      + currentdate.getFullYear() + '.txt';
  }
};
</script>

<style scoped>
.pop-over {
  padding: 2rem;
  background-color: #f0f0f2;
  position: fixed;
  margin-left: 30%;
  z-index: 20;
  width: 600px;
  height: 350px;
  margin-top: 5rem;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
}

.button-footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 40px 10px 10px 0;
}

.btn {
  width: 180px;
}


.description {
  padding: 2rem;
  font-size: 1.2rem;
  text-align: left;
}

.address {
  padding-top: 1rem;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

.btn {
  width: 160px;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.download-container {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 10px;
}
</style>
